var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosBootstrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 68,
    viewBox: "0 0 86 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_200_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7272 0C12.8582 0 9.25517 4.26167 9.41651 8.88333C9.57151 13.3233 9.37017 19.0743 7.92251 23.764C6.47051 28.4673 4.01451 31.4467 0.00317383 31.8293V36.148C4.01451 36.5307 6.47051 39.51 7.92251 44.2137C9.37017 48.9033 9.57151 54.6537 9.41651 59.094C9.25517 63.715 12.8582 67.9773 17.7278 67.9773H67.6188C72.4882 67.9773 76.0902 63.7157 75.9288 59.094C75.7742 54.654 75.9752 48.9033 77.4228 44.2137C78.8758 39.5103 81.3252 36.5303 85.3365 36.148V31.8293C81.3252 31.4467 78.8758 28.4673 77.4232 23.764C75.9752 19.075 75.7742 13.3237 75.9288 8.88333C76.0902 4.26233 72.4882 0 67.6188 0H17.7272ZM57.8565 41.8443C57.8565 48.2083 53.1098 52.0677 45.2325 52.0677H31.8225C31.439 52.0676 31.0712 51.9152 30.8 51.6439C30.5288 51.3727 30.3765 51.0049 30.3765 50.6213V17.356C30.3765 17.166 30.4138 16.9779 30.4865 16.8024C30.5592 16.6269 30.6657 16.4674 30.8 16.3331C30.9343 16.1987 31.0938 16.0922 31.2693 16.0195C31.4448 15.9468 31.6329 15.9093 31.8228 15.9093H45.1558C51.7242 15.9093 56.0348 19.4677 56.0348 24.9303C56.0348 28.7647 53.1348 32.1973 49.4405 32.7983V32.9987C54.4702 33.5503 57.8565 37.0333 57.8565 41.8443ZM43.7698 20.4943H36.1242V31.2943H42.5642C47.5422 31.2943 50.2875 29.2897 50.2875 25.7063C50.2875 22.3487 47.9265 20.4943 43.7698 20.4943ZM36.1242 35.5797V47.4813H44.0515C49.2342 47.4813 51.9802 45.4017 51.9802 41.493C51.9802 37.5837 49.1578 35.579 43.7182 35.579L36.1242 35.5797Z",
    fill: "#7E13F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.34,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosBootstrap);
export default __webpack_public_path__ + "static/media/logos_bootstrap.e7a67cc778026f203d60c51b7bc65ecf.svg";
export { ForwardRef as ReactComponent };